import { Box, styled } from '@leagueplatform/genesis-core';

// Our Get Care Masonry app supplies its own hero banner heading, so the page
// header the SDK renders above it is a duplicate heading sitting in an empty
// band. Scoped with :has() to the pages that actually have a hero banner, so
// the quick action sub-page keeps the page header and back button it relies on.
export const CareDiscoveryPageStyles = styled(Box, {
  '.care-page-wrapper:has(.masonry-page-header-background)': {
    '.cc-page-header-background': {
      display: 'none',
    },
    // Collapse the spacing that surrounded the hidden header so the hero banner
    // starts where the page heading used to.
    '> .GDS-box': {
      marginBlockStart: 0,
    },
    '.masonry-page-header-background': {
      marginBlockStart: 0,
      // The banner's background is pinned to the wrapper it sits in, so pulling
      // the banner up above leaves the background trailing below it. Shift the
      // background up by the same amount, which varies by breakpoint.
      '&:before': {
        // 24px is $oneAndHalf, the banner's default top margin.
        transform: 'translateY(-24px)',
        '@laptop': {
          transform: 'translateY(-56px)',
        },
        '@desktop': {
          transform: 'translateY(-56px)',
        },
      },
    },
  },
});
